module.exports = __webpack_public_path__ + "static/media/splotch.19dce067.svg";